import React from "react";
import {
  BoringAvatar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@bandit-network/react-ui-kit";
import { LeaderboardUser } from "@bandit-network/sdk-api";
import { truncateAddress } from "@bandit-network/utils";

export interface LeaderBoardTableProps {
  leaderBoard: Array<LeaderboardUser>;
}

const LeaderBoardTable: React.FC<LeaderBoardTableProps> = ({ leaderBoard }) => {
  return (
    <Table className="bad-quest__leaderboard--table">
      <TableHeader>
        <TableRow>
          <TableHead className="bad-quest__leaderboard--table_th_ranking">
            Ranking
          </TableHead>
          <TableHead className="bad-quest__leaderboard--table_th_user">
            User
          </TableHead>
          <TableHead className="bad-quest__leaderboard--table_th_quest_completed">
            Quest XP
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {leaderBoard.map((userData, index) => (
          <TableRow key={index}>
            <TableCell className="bad-quest__leaderboard--table_td_ranking">
              {index + 1}
            </TableCell>
            <TableCell className="bad-quest__leaderboard--table_td_user">
              <BoringAvatar size={20} name={userData?.user?.walletAddress} />
              <p className="ml-1">
                {userData?.user?.domainName
                  ? truncateAddress(userData?.user?.domainName, 6)
                  : truncateAddress(userData?.user?.walletAddress, 6)}
              </p>
            </TableCell>
            <TableCell className="bad-quest__leaderboard--table_td_quest_completed">
              {userData?.stats?.questCompleted}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export { LeaderBoardTable };
